import { render } from "./BancairesRefs.vue?vue&type=template&id=1603c146"
import script from "./BancairesRefs.vue?vue&type=script&lang=ts"
export * from "./BancairesRefs.vue?vue&type=script&lang=ts"
script.render = render

export default script